import state from './moduleMinhaContaState'
import mutations from './moduleMinhaContaMutations'
import actions from './moduleMinhaContaActions'
import getters from './moduleMinhaContaGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
